import instance from '../../../api/axios'
import { CreateParticipants, Participant } from '../types/wedding'

export const saveParticipant = async (
  participant: CreateParticipants,
): Promise<Participant[]> => {
  const response = await instance.post('/wedding/participants', participant)
  return response.data
}
